import { ValuesKnowAWord } from '../../questiontype/KnowAWord/registry/ValuesKnowAWord';
import { ValueRegistryQuestion } from './question/ValueRegistryQuestion';
import { RegistryRoof } from '../RegistryRoof';
import { ValuesOrderedChoice } from '../../questiontype/OrderedChoice/registry/ValuesOrderedChoice';
import { ValueRegistryActor } from './question/ValueRegistryActor';
import { ValuesMultipleChoice } from '../../questiontype/MultipleChoice/registry/ValuesMultipleChoice';
import { ValueRegistryMedia } from './question/ValueRegistryMedia';
export class ValueRegistry extends RegistryRoof {
    registryType = 'value';
    c_q = new ValueRegistryQuestion(this);
    c_a = new ValueRegistryActor(this);
    c_m = new ValueRegistryMedia(this);
    c_mc = new ValuesMultipleChoice(this);
    c_k = new ValuesKnowAWord(this);
    c_oc = new ValuesOrderedChoice(this);
    get registry_object() {
        return super.registry_object;
    }
}
